export const NODE_NAME_MAX_LENGTH = 40;

export const NODE_NAME_MESSAGES = {
  REQUIRED: "Node name is required.",
  NO_SPECIAL_CHARS:
    "Node name may only contain letters, numbers, and spaces (no special characters).",
  MAX_LENGTH: "Node name cannot exceed 40 characters.",
};

export const nodeNameFormatError = (value) => {
  const s = String(value ?? "").trim();
  if (!s) return "";
  if (s.length > NODE_NAME_MAX_LENGTH) {
    return NODE_NAME_MESSAGES.MAX_LENGTH;
  }
  if (!/^[a-zA-Z0-9 ]+$/.test(s)) {
    return NODE_NAME_MESSAGES.NO_SPECIAL_CHARS;
  }
  return "";
};

export const validateNodeNameForSave = (value) => {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return NODE_NAME_MESSAGES.REQUIRED;
  return nodeNameFormatError(trimmed);
};
